import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { web_url } from "../constant";
import { Mosaic } from "react-loading-indicators";

function VerifyAccount() {
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(true);
    const [text, setText] = useState('');
    const location = useLocation();
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const token = params.get("token");
        if (token) {
            setIsLoading(true);
            axios.get(`${web_url}/api/auth/verify/email?token=${token}`)
                .then(() => {
                    setText('Your account is verified successfully. Please wait, You are redirecting');
                    setIsLoading(false);
                    localStorage.clear();
                    sessionStorage.clear();
                    setTimeout(() => {
                        navigate('/loginas');
                    }, 2000);
                })
                .catch((err) => {
                    console.log('e1', err);
                    setIsLoading(false);
                    if (err.message === "Network Error") {
                        setText(`Network error. Please check your internet connection and try again.`);
                    } else {
                        setText(`Invalid token. Please try again.`);
                    }
                });
        } else {
            localStorage.clear();
            sessionStorage.clear();
            navigate('/loginas');
        }
    }, []);

    return (
        <div>
            {isLoading ? (
                <div className="flex justify-center items-center w-screen h-screen">
                    <Mosaic color="#32cd32" size="medium" text="" textColor="" />
                </div>
            ) : (
                <div className={`flex justify-center items-start w-screen h-screen pt-[100px] min-h-screen overflow-y-auto font-urban bg-bgImg md:bg-bglarge bg-repeat bg-cover`}>
                    <p className="text-center text-black font-bold text-[20px] md:text-[24px] xl:text-[27px] 2xl:text-[30px]">
                        {text}
                    </p>
                </div>
            )}
        </div>
    );
}

export default VerifyAccount;
